import { useState } from "react";

/**
 * EL BOTON DE COPIAR, uno solo para toda la app.
 *
 * Habia dos copias —una en `ListaVaults.tsx` y otra en `Auditar.tsx`— y no hacian lo mismo: la de
 * la lista paraba la propagacion del click y tenia `aria-label`, la de auditar no. Sin
 * `stopPropagation` el click sube a la fila y te saca de la lista, que es exactamente lo contrario
 * de lo que quiere quien esta copiando direcciones de varias piscinas seguidas; parar la
 * propagacion donde no hay fila que la reciba no molesta a nadie, asi que se queda la version
 * completa.
 *
 * `etiqueta` es lo que se lee en voz alta: en la lista es «la dirección», en auditar es el nombre
 * del dato. Sin ella el boton dice solo «Copiar», que ya es mejor que nada.
 *
 * Si el navegador niega el portapapeles no se avisa de nada: el texto sigue a la vista y se puede
 * seleccionar a mano. Un error ahi seria mas ruido que ayuda.
 */
export function Copiar({ texto, etiqueta }: { texto: string; etiqueta?: string }) {
  const [hecho, setHecho] = useState(false);
  const que = etiqueta ?? texto;
  return (
    <button
      className={`copiar ${hecho ? "hecho" : ""}`}
      title={hecho ? "Copiado" : `Copiar ${que}`}
      aria-label={hecho ? `Copiado ${que}` : `Copiar ${que}`}
      onClick={(e) => {
        e.stopPropagation();
        navigator.clipboard
          .writeText(texto)
          .then(() => {
            setHecho(true);
            setTimeout(() => setHecho(false), 1800);
          })
          .catch(() => { /* sin permiso de portapapeles: el texto sigue a la vista */ });
      }}
    >
      {hecho ? "✓" : "⧉"}
    </button>
  );
}
